/**
 * Custom Carousel Component 
 * @author Tiwari
 * 
 * This component would be used to demo all new react additions 
 * 
 * @props (sample) 
 * cardWidth - '12%'
 * items - Array of images
 * template {image component}
 * rightScroll, leftScroll {boolean} (optional)
 * rightScrollImage, leftScrollImage {image src} (optional)
 */

import React, { Component } from 'react';
import './carousel.scss'

export default class CustomCarousel extends Component {

	constructor(props) {

		super(props);

		this.sliderRef = React.createRef();

		const cardWidth = parseInt(this.props.cardWidth);
		const cardsPerScreen = (Math.ceil(props.items.length - Math.floor(100 / (cardWidth + 2)))) + ((100 % cardWidth) > .3 ? 1 : 0);

		this.state = {
			rightScroll: true,
			leftScroll: true,
			currentScroll: 0,
			// items: props.items,
			dotsEmptyArray: new Array(cardsPerScreen < 1 ? 1 : cardsPerScreen).fill('hello')
		}

	}

	componentWillReceiveProps(nextProps, prevProps) {
		if (prevProps.items && (prevProps.items.length == nextProps.items.length)) {
			return;
		}
		const cardWidth = parseInt(nextProps.cardWidth);
		const cardsPerScreen = (Math.ceil(nextProps.items.length - Math.floor(100 / (cardWidth + 2)))) + ((100 % cardWidth) > .3 ? 1 : 0);
		this.setState({ dotsEmptyArray: new Array(cardsPerScreen < 1 ? 1 : cardsPerScreen).fill('hello') });
	}

	componentDidMount() {
		const { autoIncrement = false } = this.props;
		if (autoIncrement) {
			this.autoSlide();
		}
	}

	autoSlide() {
		const { slideInterval = 4000 } = this.props;

		this.slideIntervalId = setInterval(() => this.scrollElement(1), slideInterval);
	}

	scrollElement = (flag, scrollCount = 1, isAbsolute) => {
		let width = this.sliderRef.firstChild.scrollWidth;
		let offset = scrollCount * width;
		let { currentScroll, dotsEmptyArray } = this.state;

		let scrollTo = 0;
		if (isAbsolute) { // when invoked via dots
			flag = currentScroll > scrollCount ? -1 : 1;
			scrollTo = offset;
			currentScroll = scrollCount;
		} else { // via next button
			let scrollindex = currentScroll + flag;
			if (scrollindex >= dotsEmptyArray.length) { // reached maximum
				return this.scrollElement(null, 0, true); // reset back to 0
			} else if (scrollindex < 0) { // reached at 0th
				return this.scrollElement(null, dotsEmptyArray.length - 1, true); // move to last
			} else {
				currentScroll = scrollindex;
			}
			scrollTo = this.sliderRef.scrollLeft + (flag * offset);
		}

		this.setState({
			currentScroll
		}, this.props.callback ? this.props.callback(currentScroll) : null);

		this.sliderRef.scrollTo({ left: scrollTo, behavior: 'smooth' });
	}

	dotsComponent() {
		return <div className='slider-individual-dots' />
	}

	render() {

		const { items, template, cardWidth, rightScroll, leftScroll, rightScrollImage, leftScrollImage, dotsComponent = this.dotsComponent, licenseCarousel } = this.props;
		const { currentScroll, dotsEmptyArray } = this.state;

		return (
			<div className="slider-container">
				<div className="slider-wrapper">

					{/* Slider Container */}
					<div className="slider" ref={(ref) => this.sliderRef = ref}>
						{
							items.map((item, key) => {
								return (
									<div style={{ width: cardWidth }} className='card' key={key}>
										{template(item, key)}
									</div>
								)
							})
						}
					</div>
					{/* Slider Container Ends */}

					{/* Navigation Buttons */}

					{licenseCarousel ?

						<div className="nav-button-profile">

							{leftScroll ? <i className={`fa fa-chevron-left arrow left-arrow ${currentScroll === 0 ? 'disabled' : ''}`} onClick={() => { this.scrollElement(1); }} aria-hidden="true"></i> : null}

							{rightScroll ? <i className={`fa fa-chevron-right arrow right-arrow ${items.length - 1 === currentScroll ? 'disabled' : ''}`} onClick={() => { this.scrollElement(-1); }} aria-hidden="true"></i> : null}

						</div>
						:
						<div className="nav-buttons">
							{leftScroll ? <button className="nav-btn nav-prev" onClick={() => {
								this.scrollElement(-1);
							}}>

								{
									leftScrollImage ? <img src={leftScrollImage} /> : <i className="fa fa-chevron-left" aria-hidden="true"></i>
								}
							</button> : null}
							{rightScroll ? <button className="nav-btn nav-next" onClick={() => {
								this.scrollElement(1)
							}}>

								{
									rightScrollImage ? <img src={rightScrollImage} /> : <i className="fa fa-chevron-right" aria-hidden="true"></i>
								}
							</button> : null}
						</div>

					}

					{/* Navigation Buttons Ends */}
				</div >
				<div className="slider-dots">
					{
						dotsEmptyArray.map((item, key) => {
							return (
								<div key={key} className={key == currentScroll ? 'active' : ''} onClick={() => this.scrollElement(key || 1, key, true)} >
									{dotsComponent()}
								</div>
							)
						})
					}
				</div>
			</div >
		);
	}
}